export default __webpack_public_path__ + "static/media/trophy.0fcd3b92.png";